<div class="reddi-assessment-main-view-card-header">
  <app-header-bar
    (routerLinkClick)="cancelAssessment()"
    *ngIf="
      (_dateOfBirth != undefined || _dateOfBirth != null) &&
      (_age != undefined || _age != null)
    "
    [age]="_age"
    [dob]="_dateOfBirth"
    [showButton]="false"
    [showClientDetails]="true"
    [title]="_clientName"
  ></app-header-bar>
</div>
<!-- Sub-Menu 1 -->
<app-sub-menu
  (navigateBackClick)="previousRoute()"
  [clientId]="_clientId"
  [flipHasAccess]="_hasAccess.flipHasAccess"
  [reddiHasAccess]="_hasAccess.reddiHasAccess"
  [showBackButton]="false"
  [showCancelDialog]="true"
  [slatHasAccess]="_hasAccess.slatHasAccess"
  [totalReviews]="_totalReviews"
/>
<form [formGroup]="reddiForm">
  <div class="reddi-assessment-page-layout">
    <div class="reddi-assessment-page-left">
      <div class="reddi-assessment-content">
        <app-primary-card>
          <div class="reddi-assessment-info">
            <app-table
              (onEditClick)="openEditModal($event.element, $event.index)"
              [columnDefinitions]="_tableColumnDefinitions"
              [columnsToDisplay]="_tableColumnsToDisplay"
              [dataSource]="_tableData"
              [noDataText]="_noDataText"
              [pageSize]="12"
              [showPager]="false"
              id="reddi-round-table"
              kind="standard"
            />
          </div>

          <div class="reddi-round-banner">
            <!-- In a parent component template -->
            <app-reddi-rounds-stepper
              [currentStep]="currentStepIndex"
              [steps]="currentStep"
            >
            </app-reddi-rounds-stepper>
          </div>
          <div class="reddi-response-section">
            <div class="reddi-distance-button-container">
              <app-reddi-distance-radio-button
                (selectionChange)="onDistanceSelectionChange($event)"
              >
              </app-reddi-distance-radio-button>
              <div
                *ngIf="
                  reddiForm.get('distance')?.touched &&
                  reddiForm.get('distance').hasError('required')
                "
                class="error-message"
              >
                <span class="error-message">
                  {{ 'Distance is required' | translate }}
                </span>
              </div>
              <div class="reddi-assessment-round-checkbox-container">
                <div class="reddi-assessment-checkbox-row">
                  <div class="reddi-assessment-round-checkbox">
                    <span>{{ 'Listening Condition' | translate }} *</span>
                    <app-reddi-tabular-checkbox
                      (checkboxChange)="
                        handleCheckboxChange($event, 'listening')
                      "
                      [checkboxes]="_checkboxesListening"
                    />
                    <div
                      *ngIf="
                        reddiForm.get('listeningConditions')?.touched &&
                        reddiForm
                          .get('listeningConditions')
                          .hasError('required')
                      "
                    >
                      <span class="error-message">
                        {{ 'Listening Condition is required' | translate }}
                      </span>
                    </div>
                  </div>
                  <div class="reddi-assessment-round-checkbox-cue">
                    <span>{{ 'Cues' | translate }} *</span>
                    <app-reddi-tabular-checkbox
                      (checkboxChange)="handleCheckboxChange($event, 'cues')"
                      [checkboxes]="_checkboxesCues"
                    />
                    <div
                      *ngIf="
                        reddiForm.get('cues')?.touched &&
                        reddiForm.get('cues').hasError('required')
                      "
                    >
                      <span class="error-message">{{
                        'Cues is required' | translate
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="reddi-assessment-round-checkbox">
                  <span>{{ 'Volume' | translate }} *</span>
                  <app-reddi-tabular-checkbox
                    (checkboxChange)="handleCheckboxChange($event, 'volume')"
                    [checkboxes]="_checkboxesVolume"
                    type="large"
                  />
                  <div *ngIf="isVolumeInvalid()">
                    <span class="error-message"
                      >{{ 'Volume is required' | translate }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="reddi-response-button-container">
              <app-spinner
                [loading]="spinnerService.loading$ | async"
              ></app-spinner>
              <table class="reddi-assessment-table">
                <colgroup>
                  <col class="col-sound" />
                  <col class="col-resp" />
                  <!-- detection positive -->
                  <col class="col-resp" />
                  <!-- detection negative -->
                  <col class="col-resp" />
                  <!-- imitation positive -->
                  <col class="col-resp" />
                  <!-- imitation negative -->
                  <col class="col-clear" />
                </colgroup>
                <thead>
                  <!-- Header row 1 -->
                  <tr class="reddi-assessment-response-header-container">
                    <th></th>
                    <!-- empty cell above sound name -->
                    <th class="reddi-assessment-response-header" colspan="2">
                      {{ 'Detection' | translate }}
                    </th>
                    <th class="reddi-assessment-response-header" colspan="2">
                      {{ 'Imitation' | translate }}
                    </th>
                    <th></th>
                    <!-- empty cell above Clear -->
                  </tr>

                  <!-- Header row 2 (icons) -->
                  <tr class="reddi-assessment-response-icon-container">
                    <th></th>
                    <!-- aligns with sound name -->
                    <th>
                      <app-reddi-response-icon
                        outcome="positive"
                        size="15"
                        type="detection"
                      />
                    </th>
                    <th>
                      <app-reddi-response-icon
                        outcome="negative"
                        size="15"
                        type="detection"
                      />
                    </th>
                    <th>
                      <app-reddi-response-icon
                        outcome="positive"
                        size="15"
                        type="imitation"
                      />
                    </th>
                    <th>
                      <app-reddi-response-icon
                        outcome="negative"
                        size="15"
                        type="imitation"
                      />
                    </th>
                    <th></th>
                    <!-- aligns with Clear -->
                  </tr>
                </thead>

                <tbody>
                  <tr
                    *ngFor="let sound of sounds; let rowIndex = index"
                    [ngClass]="{ 'alternate-row-color': rowIndex % 2 === 1 }"
                  >
                    <!-- sound name -->
                    <td class="reddi-assessment-sound-name">
                      {{ sound.name }}
                    </td>

                    <!-- 4 response buttons -->
                    <td
                      class="resp-cell"
                      *ngFor="let button of sound.rowButtons; let i = index"
                    >
                      <!-- Wrap each button in an anchor; we only use the tooltip for i === 3 -->
                      <div class="resp-anchor">
                        <app-reddi-response-button
                          (onClick)="myclick(rowIndex * 4 + i + 1)"
                          [kind]="button.kind"
                          [type]="button.type"
                          [value]="button.value"
                        ></app-reddi-response-button>

                        <!-- Tooltip only for Incorrect column (i === 3) -->
                        <div
                          class="incorrect-tooltip-container"
                          *ngIf="i === 3"
                        >
                          <app-incorrect-sound-tooltip
                            [control]="sound.incorrectSoundTooltip.control"
                            [id]="sound.incorrectSoundTooltip.id.toString()"
                            [showTooltip]="
                              sound.incorrectSoundTooltip.showTooltip
                            "
                          >
                          </app-incorrect-sound-tooltip>
                        </div>
                      </div>
                    </td>

                    <!-- clear -->
                    <td class="reddi-assessment-response-clear">
                      <app-link-button
                        (click)="clearSoundData(rowIndex)"
                        color="accent"
                        type="button"
                      >
                        {{ 'Clear' | translate }}
                      </app-link-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="reddi-footer-actions">
            <app-action-button
              (click)="isAnyButtonSelected ? addRoundData() : null"
              [color]="'primary'"
              [isDisabled]="!isAnyButtonSelected"
              [kind]="'filled'"
              [size]="'slightly-wider'"
            >
              {{ 'Add Data' | translate }}
            </app-action-button>
          </div>
        </app-primary-card>
      </div>
      <div class="reddi-assessment-page-row-2">
        <div class="reddi-response-cancel-button-container">
          <app-link-button
            (click)="cancelAssessment()"
            color="primary"
            size="slightly-wider"
          >
            {{ 'Cancel Assessment' | translate }}
          </app-link-button>
        </div>
      </div>
    </div>
    <div class="reddi-assessment-page-right">
      <div class="reddi-assessment-side-card">
        <app-side-card
          class="reddi-assessment-side-card"
          height="640"
          size="small"
        >
          <app-reddi-logo></app-reddi-logo>
          <div class="section">
            <div class="title">{{ 'Data entered by' | translate }}</div>
            <div class="text-highlight">{{ _soundEnteredByName }}</div>
            <app-dropdown
              [control]="_soundPresentedByControl"
              [data]="_soundPresentedBy"
              [required]="true"
              [errorText]="'Sound Presented By is required' | translate"
              [label]="'Sound Presented By' | translate"
              onchange="getPresenterRole($event)"
            ></app-dropdown>
          </div>
          <div class="section">
            <span class="reddi-assessment-date-picker">
              <app-datepicker
                [control]="_dateControl"
                [errorText]="'Invalid Presentation Date' | translate"
                id="presentation-date"
                [label]="'Presentation Date' | translate"
                required="true"
              />
            </span>
          </div>
          <div class="section" formArrayName="considerations">
            <div class="title">{{ 'Considerations' | translate }} *</div>
            <div *ngFor="let consideration of _considerations; let i = index">
              <input
                (change)="getConsiderations(i, $event)"
                [checked]="consideration.checked"
                [formControlName]="i"
                type="checkbox"
              />
              <span class="text">{{ consideration.label | translate }}</span>
            </div>
          </div>

          <div class="notes-section">
            <div class="title">
              <textarea
                [formControl]="_notesControl"
                class="reddi-assessment-notes-section"
                matInput
                [placeholder]="'Enter notes session' | translate"
              ></textarea>
            </div>
          </div>
        </app-side-card>
        <app-action-button
          (click)="finishSession()"
          [color]="'primary'"
          [kind]="'outline'"
          [size]="'outlined'"
        >
          {{ 'Finish Session' | translate }}
        </app-action-button>
      </div>
    </div>
  </div>
</form>
